import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../config";
import { createScheduledInvoiceItems } from "./useScheduledInvoiceItems";

export type ScheduledInvoiceItem = {
    id?: number;
    service: number | { id: number; name: string };
    quantity: number;
    price: number;
};

export type CreateInvoiceScheduleInput = {
    order: number;
    scheduled_date: string;
    status: "scheduled";
    items?: Array<ScheduledInvoiceItem>;
};



export const useCreateInvoiceSchedule = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: CreateInvoiceScheduleInput) => createInvoiceSchedule(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scheduled-invoices"] });
        },
    });
};



const createInvoiceSchedule = async (input: CreateInvoiceScheduleInput) => {
    const { items, ...scheduleData } = input;

    const response = await api({
        method: "POST",
        url: "/items/scheduled_invoices",
        data: scheduleData,
    });

    const schedule = response.data.data;

    if (items && items.length > 0) {
        await createScheduledInvoiceItems(schedule.id, items);
    }

    return schedule;
};